//@flow
import * as React from 'react'
import type { DemeterQualityReviewContainer$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const DemeterQualityReviewContainer=(props:DemeterQualityReviewContainer)=>{
    const demeter = props.demeter
    let isVisible = false

    if (demeter.reviewQuestions && demeter.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'demeterQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'demeterPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(demeter.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default DemeterQualityReviewContainer


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/QualityReviewContainer.js